import { ReactNode } from 'react';
import {
  DEFAULT_TEXT_COLOR,
  TEXT_ALIGNMENT,
  TEXT_VARIANT,
  THEME_COLOR,
  DEFAULT_TAG_STYLE,
} from '../../../theme/v2/text';
import { TextAlignment, TextVariant } from '../../../types/v2/text';
import { ThemeColors } from '../../../types/v2/theme';
import { renderNode } from '../../../utils/react.utils';

type TextProps = {
  variant?: TextVariant;
  align?: TextAlignment;
  italic?: boolean;
  color?: ThemeColors;
} & (
  | { children: ReactNode; text?: never }
  | { children?: never; text: string }
);

export default function Text(props: TextProps) {
  const { children, text, variant, align, color, italic } = props;

  // render the child
  const node = renderNode(children, text);

  // generate the styles
  const textColor = color
    ? THEME_COLOR[color || 'base']
    : DEFAULT_TEXT_COLOR[variant || 'base'];

  const textAlignment = TEXT_ALIGNMENT[align || 'left'];
  const textVariant = TEXT_VARIANT[variant || 'base'];
  const italicize = italic ? 'italic' : '';

  // concatenate the styles
  const style = `font-text ${textAlignment} ${textVariant} ${textColor} ${italicize}`;
  const tagStyle = `${style} ${DEFAULT_TAG_STYLE}`;

  return (
    <>
      {(!variant || variant === 'base') && <div className={style}>{node}</div>}
      {variant === 'navigation' && <div className={style}>{node}</div>}
      {variant === 'active-navigation' && <div className={style}>{node}</div>}
      {variant === 'month' && <div className={style}>{node}</div>}
      {variant === 'day' && <div className={style}>{node}</div>}
      {variant === 'tab' && <div className={style}>{node}</div>}
      {variant === 'label' && <div className={style}>{node}</div>}
      {variant === 'data' && <div className={style}>{node}</div>}
      {variant === 'overlay-text' && <div className={style}>{node}</div>}
      {variant === 'mobile-navigation' && <div className={style}>{node}</div>}
      {variant === 'link' && <span className={style}>{node}</span>}
      {(variant === 'supplementary' || variant === 'tooltip') && (
        <small className={style}>{node}</small>
      )}
      {variant === 'special' && <strong className={style}>{node}</strong>}
      {variant === 'tag' && <span className={tagStyle}>#{node}</span>}
      {(variant === 'username' || variant === 'alt-navigation') && (
        <div className={style}>{node}</div>
      )}
    </>
  );
}
